import { useQuery } from '@tanstack/react-query';
import { getMarketSignal, type MarketSignalParams } from '../lib/apiClient';

export function useMarketSignal(params: MarketSignalParams = {}) {
  return useQuery({
    queryKey: ['market-signal', params],
    queryFn: () => getMarketSignal(params),
    staleTime: 5 * 60_000,
    refetchInterval: 5 * 60_000,
  });
}
